export type IInitRadioUnCheck = IDCA.IGenericFunc;

function handleRadioMouseDown(e: JQuery.ClickEvent<HTMLElement>) {
  const $radio = $(e.currentTarget);
  const $formGroup = $radio.closest('.form-group');
  const $allRadios = $formGroup.find(':radio');
  const isChecked = $radio.is(':checked');
  const wasChecked = $radio.data('checked');

  if (isChecked && wasChecked) {
    $radio
      .data('checked', false)
      .attr('data-checked', false as any)
      .prop('checked', false)
      .trigger('change');
  } else {
    $allRadios.data('checked', false).attr('data-checked', false as any);
    $radio.data('checked', isChecked).attr('data-checked', isChecked as any);
  }
}

export function _initRadioUnCheck() {
  $(':radio:not(:disabled)')
    .off('click', handleRadioMouseDown)
    .on('click', handleRadioMouseDown);
}
